import React, { useState, useEffect } from 'react';
import "../Layout/Layout.css";
import "../Layout/foot.css";
function Foot() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const isScreen = windowWidth > 768;
  const content = isScreen ? <Desktop /> : <Mobile />;

  return (
    <body>
      {content}
    </body>
  );
};

const Desktop = () => {
  return (
    <body class='Desktop'>
     <div class="Foot-top">
      <div class='foot-item'>
        <p>VỀ CHÚNG TÔI</p>
        <a href="/" >Giới thiệu</a>
        <a href="/">Hệ thống cửa hàng</a>
        <a href="/">Giấy phép kinh doanh</a>
        <a href="/">Quy chế hoạt động</a>
        <a href="/">Chính sách đặt cọc</a>
        <a href="/">Chính sách nội dung</a>
        <a href="/">Chính sách đổi trả thuốc</a>
        <a href="/">Chính sách giao hàng</a>
        <a href="/">Chính sách bảo mật</a>
        <a href="/">Chính sách thanh toán</a>
        <a href="/">Kiểm tra hóa đơn điện tử</a>
        <a href="/">Chính sách bảo mật dữ liệu cá nhân</a>
        <a href="/">Chính sách hoàn hủy đổi trả Vắc xin</a>
        <a href="/">Thông tin trung tâm bảo hành máy thiết bị y tế từng hãng</a>
        <a href="/">Thể lệ chương trình “Tích điểm nhận đặc quyền”</a>
        <a href="/">Điều khoản sử dụng Long Châu 247</a>
      </div>
      <div class='foot-item'>
        <p>DANH MỤC</p>
        <a href="/">Thực phẩm chức năng</a>
        <a href="/">Dược mỹ phẩm</a>
        <a href="/">Thuốc</a>
        <a href="/">Chăm sóc cá nhân</a>
        <a href="/">Trang thiết bị y tế</a>
        <a href="/">Đặt thuốc online</a>
        <a href="/">Tiêm chủng Long Châu</a>
      </div>
      <div class='foot-item'>
        <p>TÌM HIỂU THÊM</p>
        <a href="/">Góc sức khoẻ</a>
        <a href="/">Tra cứu thuốc</a>
        <a href="/">Tra cứu dược chất</a>
        <a href="/">Tra cứu dược liệu</a>
        <a href="/">Bệnh thường gặp</a>
        <a href="/">Bệnh viện</a>
        <a href="/">Đội ngũ chuyên môn</a>
        <a href="/">Tin tức tuyển dụng</a>
        <a href="/">Tin tức sự kiện</a>
      </div>
      <div class='foot-item'>
        <p>TỔNG ĐÀI (8:00-22:00)</p>
        <p>Tư vấn mua hàng</p>
        <p><span>18006928</span> (Nhánh 1)</p>
        <p>Trung tâm Vắc xin</p>
        <p><span>18006928</span> (Nhánh 2)</p>
        <p>Góp ý, khiếu nại và tiếp nhận cảnh báo thông tin vi phạm</p>
        <p><span>18006928</span> (Nhánh 3)</p>
        <p>Tư vấn mua hàng</p>
        <p>HỖ TRỢ THANH TOÁN</p>
      </div>
      <div class='foot-item'>
        <p>KẾT NỐI VỚI CHÚNG TÔI</p>
        <p>HỖ TRỢ THANH TOÁN</p>
      </div>
     </div>
     <div class="Foot-bot">
      <hr></hr>
      <p>© 2007 - 2026 Công ty Cổ Phần Dược Phẩm FPT Long Châu Số ĐKKD 0315275368 cấp ngày 17/09/2018 tại Sở Kế hoạch Đầu tư TPHCM GP thiết lập TTTĐTTH số 538/GP-TTĐT do Sở TTTT Hồ Chí Minh cấp ngày 27 tháng 03 năm 2025</p>
      <ul>
        <li>Địa chỉ: 379-381 Hai Bà Trưng, P. Xuân Hoà, TP. Hồ Chí Minh</li>
        <li>Số điện thoại: (028)73023456</li>
        <li>Email: sale@nhathuoclongchau.com.vn</li>
        <li>Người chịu trách nhiệm nội dung: Phạm Phú Sang</li>
      </ul>
     </div>
    </body>
  );
};
const Mobile = () => {
  return (
    <body>
       
    </body>
  );
};
export default Foot;
